export function redirectToDash(navigate,toast,wait){
      navigate("/")
      if(wait){
        setTimeout(() => {
            toast.error("You don't have the permission to access this page.")
        }, 500);
      }else{
        toast.error("You don't have the permission to access this page.")
      }
}